import styled from "styled-components"

import { colors, spacing, Text } from "@minuthq/meatball-ui-react"

import { LinearProgressBar } from "src/components/ProgressBar/LinearProgressBar"
import { breakpoint } from "src/constants/breakpoints"
import { useTranslate } from "src/i18n/useTranslate"
import { Divider } from "src/ui/Divider/Divider"
import { DonutChart } from "src/ui/Graphs/DonutChart"
import { MCard } from "src/ui/MCard/MCard"

export function PortfolioAnalyticsIntegrationsStatus() {
  const { tPlaceholder, t } = useTranslate()

  return (
    <StyledMCard padding={spacing.M} boxShadow={false} border={true}>
      <Text variant="heading3">{tPlaceholder("Integrations status")}</Text>

      <IntegrationStatusContent>
        <IntegrationStatusSection>
          <Text variant="bodyS" color="secondary">
            {tPlaceholder(
              "See units per PMS and how many of them are linked or not linked to Minut."
            )}
          </Text>

          <DonutChart
            title={{
              text: "60/80",
            }}
            data={[
              { name: "with Minut", y: 60 },
              { name: "in other PMS", y: 20 },
            ]}
            seriesColors={[colors.systemGood, colors.neutralDark2]}
            containerProps={{ style: { height: 300 } }}
            labelFormatter={function (this: Highcharts.Point): string {
              return `<span>
                <b>${this.y} ${t("unit_plural")}</b> - ${this.name}
              </span>`
            }}
          />
        </IntegrationStatusSection>

        <StyledDivider />
        <IntegrationStatusSection>
          <Text variant="bodyS" color="secondary">
            {tPlaceholder(
              "See units per PMS and how many of them are linked or not linked to Minut."
            )}
          </Text>
          <LinkedIntegrationsList>
            {Array.from({ length: 3 }).map((_, index) => (
              <LinkedIntegrationItem key={index} />
            ))}
          </LinkedIntegrationsList>
        </IntegrationStatusSection>
      </IntegrationStatusContent>
    </StyledMCard>
  )
}

function LinkedIntegrationItem() {
  const { tPlaceholder } = useTranslate()

  return (
    <LinkedIntegrationsCard padding={spacing.M} boxShadow={false} border={true}>
      <IntegrationIcon />
      <IntegrationContent>
        <Text variant="heading3">{tPlaceholder("Integration name")}</Text>
        <IntegrationStats>
          <StatsRow>
            <Text variant="bodyS" color="tertiary">
              12/32 {tPlaceholder("units linked")}
            </Text>
            <Text variant="bodyS" color="tertiary">
              32 {tPlaceholder("units listed in PMS")}
            </Text>
          </StatsRow>
          <LinearProgressBar
            segments={[
              { value: 30, type: "good" },
              { value: 3, type: "error" },
            ]}
          />
        </IntegrationStats>
      </IntegrationContent>
    </LinkedIntegrationsCard>
  )
}

const StyledDivider = styled(Divider)`
  @container (${breakpoint.mediumUp}) {
    width: 1px;
    height: 100%;
  }
`

const IntegrationStatusContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.L};

  @container (${breakpoint.mediumUp}) {
    grid-template-columns: 1fr auto 1fr;
  }
`

const IntegrationStatusSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
`

const StyledMCard = styled(MCard)`
  display: grid;
  gap: ${spacing.M};
`

const LinkedIntegrationsCard = styled(MCard)`
  display: flex;
  gap: ${spacing.M};
`

const LinkedIntegrationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};
`

const IntegrationIcon = styled.div`
  background-color: red;
  aspect-ratio: 1;
  width: 56px;
  height: 56px;
`

const IntegrationContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const IntegrationStats = styled.div`
  display: grid;
  gap: ${spacing.XS3};
`

const StatsRow = styled.div`
  display: flex;
  justify-content: space-between;
`
